import { Group } from "src/app/backend/models/group/group";
import { Role } from "src/app/backend/models/role/role";
import { User } from "src/app/backend/models/user/user";

export enum MemberScope {
  PLATFORM = "platform",
  DOMAIN = "domain",
  TENANT = "tenant"
}

export enum MemberPosition {
  MEDICAL = "medical",
  TECHNICAL = "technical",
  ADMINISTRATIVE = "administrative"
}

export interface Member {
  id: string;
  firstName: string;
  lastName: string;
  username: string;
  roles?: Role[];
  groups?: Group[];
  user?: User;
  email: string;
  number: string;
  color?: string;
  disabled?: boolean;
  status?: string;
  type?: string;
  position?: MemberPosition;
  system?: boolean;
  scope: MemberScope;
  wards?: string[];
  bookable?: boolean;
  updatedAt?: string | Date;
}

export type MemberLight = Pick<
  Member,
  "id" | "firstName" | "lastName" | "email" | "number" | "color" | "position"
> & {
  signature?: string;
  professionalRegisterNumber: string | undefined;
  professionalRegisterProvince: string | undefined;
  professionalRegisterSignedAt: string | undefined;
  wards?: string[];
  bookable?: boolean;
  rev?: {
    username: string;
    password: string;
  };
};
